import React from "react";

import NewsletterForm from "./NewsletterForm";

function Newsletter() {
  return (
    <div className="post__injectable">
      <div className="newsletter">
        <p className="newsletter__heading">Newsletter</p>
        <NewsletterForm />
      </div>
    </div>
  );
}

export default Newsletter;
